import React from "react";

export default function WorkbenchTabs({ activeTab, onChange }) {
  const tabs = [
    { id: "workbench", label: "Workbench" },
    { id: "bases", label: "Bases da simulacao" },
  ];

  return (
    <div className="swb-tabs" role="tablist" aria-label="Modo do simulador">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={activeTab === tab.id}
          className={`swb-tab ${activeTab === tab.id ? "is-active" : ""}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
